import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HighlightPipe } from '../../pipes';

import { Params, RouterLink } from '@angular/router';

@Component({
  selector: 'core-highlighted-text',
  imports: [HighlightPipe, RouterLink],
  templateUrl: './highlighted-text.component.html',
  styleUrl: './highlighted-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HighlightedTextComponent {
  value = input<string | null>('');
  highlight = input<string | null>('');
  routerLink = input<string[] | null>([]);
  queryParams = input<Params | null>();
  class = input<string | null>('');
}
